import { ENDPOINTS } from '@/constants/api'
import { QUERY_KEYS } from '@/constants/query-keys'
import type { ResponseData } from '@/types/api'
import { apiSlice } from './base'

export type Tenant = ResponseData<'/api/v1/tenants/current', 'get'>

export const tenantsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentTenant: builder.query<Tenant, void>({
      query: () => ENDPOINTS.TENANTS.CURRENT,
      transformResponse: (response: { data: Tenant }) => response.data,
      providesTags: [{ type: QUERY_KEYS.TENANT, id: 'CURRENT' }],
    }),
  }),
  overrideExisting: false,
})

export const { useGetCurrentTenantQuery } = tenantsApi
